
const reducers = {

  ERROR: (state, { error, code }) => {
    console.error(error);
    return {
      ...state,
      error: { code, exist: true, message: error }
    };
  },

  GET_EMPLOYESS: (state, payload) => {
    return {
      ...state,
      employess: payload.employees
    };
  },

  CREATE_EMPLOYEE: (state, payload) => {
    return {
      ...state,
      employess: [payload.employee, ...state.employess]
    };
  },

  EDIT_EMPLOYEE: (state, payload) => {
    const { employee } = payload
    const employessArray = [...state.employess]
    const index = state.employess.findIndex(dataEm => dataEm._id === employee._id);
    employessArray[index] = employee
    return {
      ...state,
      employess: employessArray,
      selectedEmployee: employee
    };
  },

  DELETE_EMPLOYEE: (state, payload) => {
    return {
      ...state,
      employess: state.employess.filter(employee => employee._id !== payload.employee),
      //rest values of the sidebar
      isSidebarRightOpen: !state.isSidebarRightOpen,
      selectedEmployee: null,
    };
  },

  SET_SIDEBAR_RIGHT: (state, payload) => {
    return {
      ...state,
      isSidebarRightOpen: !state.isSidebarRightOpen
    };
  },

  SET_SELECTED_EMPLOYEE: (state, payload) => {
    return {
      ...state,
      selectedEmployee: payload.employeeData
    };
  },
}
export default reducers;